require('../../modules/web.dom-collections.for-each');

module.exports = require('../../internals/array-for-each');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/features/dom-collections/for-each.js
// module id = 229
// module chunks = 168707334958949